import { createContext, useContext, useMemo, type ReactNode } from 'react';

export interface AuthContextValue {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
  email?: string;
  organisationId?: string;
}

const AuthContext = createContext<AuthContextValue>({});

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}

interface AuthProviderProps {
  readonly getAccessToken?: () => Promise<string | null>;
  readonly instanceId?: string;
  readonly email?: string;
  readonly organisationId?: string;
  readonly children: ReactNode;
}

export function AuthProvider({ getAccessToken, instanceId, email, organisationId, children }: Readonly<AuthProviderProps>): React.ReactElement {
  const value = useMemo(
    () => ({ getAccessToken, instanceId, email, organisationId }),
    [getAccessToken, instanceId, email, organisationId]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
